export class PaymentSubmitModel {
  public cardOwner: string;
  public cardNumber: string;
  public validate: string;
  public securityCode: string;
  public numberOfInstallments: number;
  public proposalNumber: string;
  public brandCard: string;
}
